import type { ApiClient } from "./client";

/** Public metadata shown on the invite sign-up page before redeeming. */
export interface InvitePreview {
  email: string;
  workspace_name: string;
  expires_at: string;
}

export interface RedeemInviteRequest {
  token: string;
  name: string;
  password: string;
  /** RFC3339 timestamp — when the recording-consent box was checked. */
  consent_at: string;
}

export interface RedeemInviteResponse {
  user_id: string;
  email: string;
  workspace_name: string;
  tenant_id: string;
  role: string;
}

// Unauthenticated onboarding endpoints. They go through ApiClient (not raw
// fetch) so the CSRF token is primed + sent — the API mounts them behind the
// same CSRF middleware as the rest of /api/v1.
export const invitesApi = (client: ApiClient) => ({
  preview: (token: string) =>
    client.get<InvitePreview>(`/api/v1/invites/preview?token=${encodeURIComponent(token)}`),
  redeem: (body: RedeemInviteRequest) =>
    client.post<RedeemInviteResponse>("/api/v1/invites/redeem", body),
});
